module.exports = __webpack_public_path__ + "static/media/atmed_logo.370cde31.svg";